import { createContainer } from 'react-sweet-state';

import { progressStore, type Actions, type ProgressState } from 'src/store/progress/progressStore';

export const ProgressContainer = createContainer<ProgressState, Actions>(progressStore, {
  displayName: 'ProgressContainer',
});
